import { color } from '$tablet-app/src/app/theme';
import React, { FC, View } from 'react';
import { StyleProp } from 'react-native';
import styled from 'styled-components/native';

interface Props {
  initial: string;
  height: number;
  width: number;
  style?: StyleProp<View>;
}

export const ContactPlaceholder: FC<Props> = (props) => {
  const { initial, height, width, style } = props;
  return (
    <ContactPlaceholderContainer
      style={[{ height: height, width: width }, style]}
    >
      <ContactInitial>{initial}</ContactInitial>
    </ContactPlaceholderContainer>
  );
};

const ContactPlaceholderContainer = styled.View`
  height: 48px;
  width: 48px;
  border-radius: 15px;
  justify-content: center;
  align-items: center;
  background-color: ${color.secondary};
`;

const ContactInitial = styled.Text`
  font-weight: bold;
`;

export default ContactPlaceholder;
